// Originally generated from the single-file app (index.html) during the React migration.
// Edit freely: this file is now the source of truth.
export const TRANSLATION_KEYS = [
  "syncToDbNoRows",
  "syncToDbDone",
  "syncToDbSystemDone",
  "syncToDbNoSystem",
  "syncToDbFailed",
  "syncToDbPartial",
  "localFileError",
  "logout",
  "title",
  "tabList",
  "tabMatrix",
  "tabStats",
  "tabSystem",
  "tabAdmin",
  "listTitle",
  "listNumber",
  "listName",
  "listLocation",
  "arena",
  "listColor",
  "listLinks",
  "listEdit",
  "listActions",
  "saveButton",
  "deleteButton",
  "deleteConfirm",
  "editTitleRequired",
  "editSaveError",
  "editRefreshError",
  "editDeleteError",
  "editApproveError",
  "editReturnError",
  "approveButton",
  "returnButton",
  "returnToDraftConfirm",
  "returnToDraftPublishedConfirm",
  "saveDraftButton",
  "submitButton",
  "statusDraft",
  "statusSubmitted",
  "statusApproved",
  "classificationHeading",
  "workingCommentsHeading",
  "workingCommentsHint",
  "workingCommentsEmpty",
  "lastUpdated",
  "createdAt",
  "changeHistory",
  "historyEmpty",
  "historyLoadError",
  "historyMore",
  "historyCreated",
  "historyUpdated",
  "historyStatus",
  "historyDeleted",
  "historyCustomField",
  "historyComment",
  "historyQuestionnaire",
  "historyChangedField",
  "historyCharacters",
  "updatedBy",
  "updatedByUnknown",
  "listStatus",
  "newInterventionButton",
  "respondentIntroTitle",
  "respondentIntroText",
  "respondentStepRegisterTitle",
  "respondentStepRegisterText",
  "respondentStepReviewTitle",
  "respondentStepReviewText",
  "respondentStepPublishedTitle",
  "respondentStepPublishedText",
  "respondentSensitiveTitle",
  "respondentSensitiveText",
  "respondentContact",
  "respondentIntroShow",
  "respondentIntroHide",
  "respondentListTitle",
  "newInterventionBadge",
  "interventionEditorTitle",
  "interventionEditorIntroduction",
  "respondentNoSubmissions",
  "detailsAge",
  "detailsYears",
  "detailsNoDescription",
  "detailsNoSources",
  "detailsSources",
  "formDisplayInformationTab",
  "formDataTab",
  "formDataNotice",
  "formFetchDisplayInformation",
  "formCopyConfirm",
  "formCopyDone",
  "formLoadError",
  "formUnknownVersion",
  "formNoResponse",
  "formInvalidNumber",
  "formChooseLocation",
  "adminLocationQuestionnaire",
  "adminGdprTitle",
  "adminGdprDescription",
  "adminGdprColId",
  "adminGdprColName",
  "adminGdprColCount",
  "adminGdprColActions",
  "adminGdprResponseCount",
  "adminGdprResponsesDelete",
  "adminGdprResponsesConfirm",
  "adminGdprResponsesDeleteSuccess",
  "adminGdprResponsesDeleteError",
  "formTitle",
  "formDescription",
  "formYoungest",
  "formOldest",
  "formLinksLabel",
  "respondentPageTitle",
  "listEmpty",
  "labelView",
  "location",
  "objective",
  "labelFile",
  "fileButton",
  "syncToDbButton",
  "syncToDbButtonWorking",
  "authGateTitle",
  "authGateSubtitle",
  "authEmailLabel",
  "authPasswordLabel",
  "authLoginButton",
  "authForgotButton",
  "authErrorGeneric",
  "authRoleInvalid",
  "authSessionExpired",
  "supabaseNotConfigured",
  "authResetSent",
  "authResetNeedsEmail",
  "authSetPasswordSubtitle",
  "authNewPasswordLabel",
  "authConfirmPasswordLabel",
  "authSetPasswordButton",
  "authPasswordMismatch",
  "authSetPasswordError",
  "adminPanelTitle",
  "adminInviteHeading",
  "adminInviteEmailLabel",
  "adminInviteRoleLabel",
  "adminInviteRoleLocalAdmin",
  "adminInviteRoleLocalReader",
  "adminInviteRoleRespondent",
  "adminInviteRoleRespondentRead",
  "adminInviteRoleSuperAdmin",
  "adminInviteLocationLabel",
  "adminInviteLocationPlaceholder",
  "adminInviteSubmit",
  "adminUsersHeading",
  "adminColEmail",
  "adminColRole",
  "adminColLocation",
  "adminColActions",
  "adminDeleteButton",
  "adminDeleteConfirm",
  "adminInviteSuccess",
  "adminInviteError",
  "adminInviteLocationRequired",
  "adminUsersLoadError",
  "adminUsersEmpty",
  "adminDeleteError",
  "adminEditButton",
  "adminCancelButton",
  "adminEditSelfHint",
  "adminEditNotAllowedHint",
  "adminRoleUpdated",
  "adminRoleUpdateError",
  "adminLocationsTitle",
  "adminLocationCreateHeading",
  "adminLocationIdLabel",
  "adminLocationNameLabel",
  "adminLocationSubmit",
  "adminLocationsHeading",
  "adminLocationColId",
  "adminLocationColName",
  "adminLocationIdLengthError",
  "adminLocationCreateSuccess",
  "adminLocationCreateError",
  "adminLocationsLoadError",
  "adminLocationsEmpty",
  "adminLocationDeleteConfirm",
  "adminLocationDeleteError",
  "adminLocationDeleteAssignedError",
  "adminAgeGroupsTitle",
  "adminAgeGroupsDescription",
  "adminAgeGroupsName",
  "adminAgeGroupsFrom",
  "adminAgeGroupsTo",
  "adminAgeGroupsRemove",
  "adminAgeGroupsAdd",
  "adminAgeGroupsSave",
  "adminAgeGroupsSaved",
  "adminAgeGroupsLoadError",
  "adminAgeGroupsSaveError",
  "adminAgeGroupsInvalidCount",
  "adminAgeGroupsInvalidName",
  "adminAgeGroupsInvalidRange",
  "adminAgeGroupsInvalidContinuous",
  "adminAgeGroupsInvalidKey",
  "adminArenasTitle",
  "adminArenasDescription",
  "languagesTitle",
  "adminSubmenuLabel",
  "adminMenuUsers",
  "adminMenuLocations",
  "adminMenuAgeGroups",
  "adminMenuArenas",
  "adminMenuExport",
  "adminDefaultUrlTitle",
  "adminDefaultUrlDescription",
  "adminDefaultUrlLabel",
  "adminDefaultUrlSave",
  "adminDefaultUrlSaved",
  "adminDefaultUrlError",
  "adminDefaultUrlViewUnavailable",
  "adminExportTitle",
  "adminExportDescription",
  "adminExportDatasetLabel",
  "adminExportDatasetInterventions",
  "adminExportDatasetSystemData",
  "adminExportDatasetSystemCriteria",
  "adminExportLocationLabel",
  "adminExportAllLocations",
  "adminExportButton",
  "adminExportTemplateOnly",
  "adminExportTemplateButton",
  "adminExportTemplateDone",
  "adminExportWorking",
  "adminExportDone",
  "adminExportEmpty",
  "adminExportError",
  "adminExportNoLocation",
  "adminExportSharedNote",
  "adminMenuExperimental",
  "adminExperimentalTitle",
  "adminExperimentalDescription",
  "adminExperimentalOverTimeLabel",
  "adminExperimentalOverTimeDescription",
  "adminExperimentalSaved",
  "adminExperimentalSaveError",
  "languagesDescription",
  "dictionaryNavigation",
  "dictionaryAdmin",
  "dictionaryAuth",
  "dictionaryForms",
  "dictionarySystem",
  "dictionaryStatistics",
  "dictionaryGeneral",
  "dictionaryClassifications",
  "dictionaryCategories",
  "dictionaryObjectives",
  "dictionarySearch",
  "dictionarySearchEmpty",
  "languageCsvExport",
  "languageCsvImport",
  "languageCsvHint",
  "languageCsvExported",
  "languageCsvImported",
  "languageCsvConfirm",
  "languageCsvError",
  "languageCsvSettings",
  "languageCsvSyntax",
  "languageCsvHeader",
  "languageCsvNames",
  "languageCsvColumns",
  "languageCsvKey",
  "languageCsvDuplicate",
  "languageCsvUnregistered",
  "languageCsvEnglish",
  "adminViewsTitle",
  "adminCustomFieldsTitle",
  "adminCustomFieldsDescription",
  "adminCustomFieldInvalidKey",
  "adminCustomFieldRequiredEnglish",
  "adminCustomFieldInvalidCss",
  "adminCustomFieldInvalidLocation",
  "adminCustomFieldLoadError",
  "adminCustomFieldSaveError",
  "adminCustomFieldDeleteError",
  "adminCustomFieldDeleteConfirm",
  "adminCustomFieldNew",
  "adminCustomFieldLoading",
  "adminCustomFieldEmpty",
  "adminCustomFieldAdd",
  "adminCustomFieldDefinition",
  "adminCustomFieldNameEn",
  "adminCustomFieldId",
  "adminCustomFieldIdHint",
  "adminCustomFieldPresentation",
  "adminCustomFieldLocation",
  "adminCustomFieldAllLocations",
  "adminCustomFieldType",
  "adminCustomFieldSingleLine",
  "adminCustomFieldMultiLine",
  "adminCustomFieldSortOrder",
  "adminCustomFieldCssClass",
  "adminCustomFieldCssHint",
  "adminCustomFieldAdminOnly",
  "adminCustomFieldDelete",
  "adminCustomFieldUnsaved",
  "adminCustomFieldNoChanges",
  "adminCustomFieldSaving",
  "adminCustomFieldSave",
  "adminCustomFieldCreate",
  "adminCustomFieldAdminBadge",
  "adminViewsDescription",
  "adminViewSelect",
  "adminViewAdd",
  "adminViewDiscard",
  "adminViewDelete",
  "adminViewDeleteConfirm",
  "adminViewDeleteConfirmShared",
  "adminViewsSave",
  "adminViewsSaved",
  "adminViewsError",
  "adminViewsLoadError",
  "adminViewsInvalid",
  "adminViewId",
  "adminViewNameEn",
  "adminViewNameNo",
  "adminViewColumn",
  "adminViewNewColumn",
  "adminViewType",
  "adminViewNumeric",
  "adminViewCategorical",
  "adminViewLayout",
  "adminViewOrder",
  "adminViewVisible",
  "adminViewChips",
  "adminViewChipsHidden",
  "adminViewChipsView",
  "adminViewChipsObjectives",
  "adminViewDetails",
  "adminViewCategories",
  "adminViewCategoryAdd",
  "adminViewCategoryCode",
  "adminViewColor",
  "adminViewPattern",
  "adminViewSolid",
  "adminViewStriped",
  "adminViewStripeColor",
  "adminViewStripeBackground",
  "adminViewTextColor",
  "adminViewTextAuto",
  "adminViewTextBlack",
  "adminViewTextWhite",
  "adminViewUp",
  "adminViewDown",
  "adminViewRemove",
  "adminViewRemoveConfirm",
  "adminViewCategoryUsed",
  "adminViewUntitled",
  "adminViewNewBadge",
  "adminViewHiddenBadge",
  "adminViewSectionNames",
  "adminViewSectionSource",
  "adminViewSectionDisplay",
  "adminViewLockedHint",
  "adminUnsavedChanges",
  "adminAllChangesSaved",
  "languageMaster",
  "languageTranslation",
  "languageCode",
  "languageName",
  "languageAdd",
  "languageDelete",
  "languageDeleteConfirm",
  "languageSectionLanguages",
  "languageSectionCsv",
  "languageSectionTranslations",
  "languageSourceBadge",
  "languageKey",
  "languageOnlyUntranslated",
  "languageUntranslatedBadge",
  "languageSearchCount",
  "languageGroupEmpty",
  "languageAllTranslated",
  "languagesSave",
  "languagesSaved",
  "languagesError",
  "languagesInvalid",
  "languagesLoadError",
  "adminArenasName",
  "adminArenasOrder",
  "adminArenasAdd",
  "adminArenasRemove",
  "adminArenasSave",
  "adminArenasSaved",
  "adminArenasLoadError",
  "adminArenasSaveError",
  "adminArenasInvalidCount",
  "adminArenasInvalidKey",
  "adminArenasInvalidName",
  "adminArenasInvalidOrder",
  "adminArenasRemoveConfirm",
  "formArenaPlaceholder",
  "formArenaRequired",
  "formAgeRequired",
  "searchPlaceholder",
  "searchClear",
  "allLocations",
  "locationsSelected",
  "allObjectives",
  "objectivesSelected",
  "infoDefault",
  "statsTitle",
  "tiltaksnivaTitle",
  "regionTitle",
  "sectorTitle",
  "ageTitle",
  "tiltaksklasseTitle",
  "initialFilteringTitle",
  "kunnskapTitle",
  "evidencelevelTitle",
  "stackedAgeTitle",
  "stackedTiltaksklasseTitle",
  "stackedInitialFilteringTitle",
  "stackedTiltakTitle",
  "stackedSectorTitle",
  "forklaring",
  "unclassifiedItems",
  "ikkeAngitt",
  "ingen",
  "showLabels",
  "hideLabels",
  "labels",
  "noLabels",
  "labelsOn",
  "labelsOff",
  "showItemIds",
  "hideItemIds",
  "ids",
  "noIds",
  "idsOn",
  "idsOff",
  "moreDetails",
  "detailsLevel0",
  "detailsLevel1",
  "detailsLevel2",
  "showMoreDetails",
  "hideMoreDetails",
  "hideMoreDetails2",
  "listDescription",
  "readMore",
  "showUnclassified",
  "hideUnclassified",
  "unclassified",
  "noUnclassified",
  "unclassifiedShow",
  "unclassifiedHide",
  "showAll",
  "hideAll",
  "showFilters",
  "hideFilters",
  "filtersShow",
  "filtersHide",
  "closeDetails",
  "moveDetailsRight",
  "moveDetailsBelow",
  "systemLocation",
  "systemAnalysis",
  "systemAbout",
  "systemAboutTitle",
  "systemAboutText",
  "systemSummaryLabel",
  "systemDomain",
  "systemCriterion",
  "systemAssessment",
  "systemEvidence",
  "systemSource",
  "systemWorkingComment",
  "systemSector",
  "systemInterventionType",
  "systemInterventionReach",
  "systemNoCriteria",
  "systemCreateAnalysis",
  "systemEditAnalysis",
  "systemCreateAnalysisTitle",
  "systemEditAnalysisTitle",
  "systemCreateAnalysisDescription",
  "systemCreateAnalysisYear",
  "systemCreateAnalysisLocation",
  "systemCreateAnalysisCriteriaSet",
  "systemCreateAnalysisChooseCriteriaSet",
  "systemCreateAnalysisCriteriaSetOption",
  "systemCreateAnalysisCriteriaSetRequired",
  "systemCreateAnalysisChooseScore",
  "systemCreateAnalysisAssessment",
  "systemAnalysisAssessmentDetails",
  "systemAnalysisNextLevel",
  "systemCreateAnalysisCancel",
  "systemCreateAnalysisSave",
  "systemCreateAnalysisSuccess",
  "systemCreateAnalysisError",
  "systemCreateAnalysisDuplicate",
  "systemCreateAnalysisNoCriteria",
  "systemCreateAnalysisRefreshError",
  "systemAnalysisLastChanged",
  "systemAnalysisLoadError",
  "databaseLoadError",
  "systemNoSelection",
  "systemFulfilled",
  "systemAlmostFulfilled",
  "systemPartiallyFulfilled",
  "systemOnlyLimited",
  "systemNotFulfilled",
  "systemInsufficientInformation",
  "systemZero",
  "systemViewLabel",
  "systemViewSingle",
  "systemViewOverTime",
  "systemPeriod",
  "systemNotAssessed",
  "systemPeriodAll",
  "systemPeriodLastTwo",
  "systemFirstAnalysisPill",
  "systemOverTimeTitle",
  "systemOverTimeNoData",
  "systemCheckpoint",
  "systemSince",
  "systemImproved",
  "systemWorse",
  "systemOverallScore",
  "systemFirstAnalysisNote",
  "systemFirstAnalysisTitle",
  "systemFirstAnalysisText",
  "systemPlanAnalysis",
  "systemUnknown",
  "systemLegendFulfilled",
  "systemLegendAlmostFulfilled",
  "systemLegendPartiallyFulfilled",
  "systemLegendOnlyLimited",
  "systemLegendNotFulfilled",
  "systemLegendInsufficientInformation",
  "systemLegendZero",
  "systemAggregateRule",
  "systemMostSeriousStatus",
  "systemFilterAllLocations",
  "systemShowAll",
  "systemHideAll",
  "systemCloseDetails",
  "systemDetailsBoxTitle",
  "systemNoLocationScores",
  "systemToggleScale",
] as const;

export type TranslationKey = (typeof TRANSLATION_KEYS)[number];
export type TranslationTable = Record<TranslationKey, string>;
